import { createStylesContext } from '@chakra-ui/system';

export const COMPONENT_NAME = 'Input';

export const [StylesProvider, useStyles] = createStylesContext(COMPONENT_NAME);
